import React from 'react';
import PropTypes from 'prop-types';

export class ButtonLabel extends React.Component {

    render() {
        const {
            label,
            disabled,
            className,
            onClick,
        } = this.props;

        return (
            <div className={className}>
                <button
                    className="btn btn-lg btn-block btn-primary waves-effect form-btn"
                    disabled={disabled}
                    children={label.toUpperCase()}
                    onClick={onClick}
                />
            </div>
        );
    }

}

ButtonLabel.propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/ButtonLabel.js